import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useEffect, useState } from "react";
import { cashfree } from "../../utils/cashfree.util";
import { get, post } from "../../redux/ApiHelper";
import { errorToast, successToast } from "../../utils/toast.util";
import { DispatchType } from "../../interfaces/redux.interface";
import { getInfo } from "../../redux/slices/InfoSlice";
import { startLoading, stopLoading } from "../../redux/slices/WindowSlice";
import { setSignedAdmin } from "../../redux/slices/AdminSlice";
import { isPackageActive } from "../../utils/helper.util";
import { formatDateTime } from "../../utils/date&time.util";

const AdminPass = () => {
  const [loading, setLoading] = useState(false);
  const dispatch: DispatchType = useDispatch();
  const { signedAdmin } = useSelector((state: RootState) => state.admin);
  // console.log(signedAdmin);
  const { info } = useSelector((state: RootState) => state.info);
  const [adminPack, setAdminPack] = useState({
    validity: 30,
    amount: 15000,
  });
  useEffect(() => {
    if (!info) {
      dispatch(startLoading());
      dispatch(getInfo()).finally(() => {
        dispatch(stopLoading());
      });
    }

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (info) {
      setAdminPack(info.franchiseAdminPack);
    }
    // eslint-disable-next-line
  }, [info]);

  const checkPaymentStatus = async (orderId: string) => {
    post(`/admin/payment/payment-franchise/order-validate/${orderId}`, {})
      .then(async (res) => {
        if (res.success) {
          const url = new URL(window.location.href);
          url.search = ""; // Removes all search parameters
          window.history.pushState({}, document.title, url.toString());
          successToast("Payment successful!");

          // Fetch latest admin info after successful payment
          try {
            const response = await get("/admin/auth/info");
            dispatch(
              setSignedAdmin({
                email: response.email,
                role: response.role,
                type: response.type,
                name: response.name,
                phoneNumber: response.phoneNumber,
                accessValidity: response.accessValidity ?? "",
                id: response.id,
                franchisePackAmount: response.franchisePackAmount,
              })
            );
          } catch (err) {
            console.error("Failed to fetch admin info after payment", err);
          }
        } else {
          errorToast(res.message || "Payment failed.");
        }
      })
      .catch((error) => {
        console.error("Error during payment:", error);
      });
    sessionStorage.clear();
  };

  const refreshPaymentStatus = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const orderId = queryParams.get("orderId");

    // To prevent multiple executions
    const paymentHandled = sessionStorage.getItem(`paymentHandled_${orderId}`);
    if (orderId && !paymentHandled) {
      sessionStorage.setItem(`paymentHandled_${orderId}`, "true");
      checkPaymentStatus(orderId).then(async () => {});
    }
  };
  useEffect(() => {
    refreshPaymentStatus();
    get("/admin/auth/info")
      .then((response) => {
        dispatch(
          setSignedAdmin({
            email: response.email,
            role: response.role,
            type: response.type,
            name: response.name,
            phoneNumber: response.phoneNumber,
            accessValidity: response.accessValidity ?? "",
            id: response.id,
            franchisePackAmount: response.franchisePackAmount,
          })
        );
      })
      .catch((error) => {});
  }, []);

  const handlePayment = async (amount: number) => {
    try {
      setLoading(true);
      const paymentDetails = {
        name: "Franchise admin " + signedAdmin.name,
        email: signedAdmin.email,
        phone: `${signedAdmin.phoneNumber}`,
        amount,
        productInfo: `Franchise admin access after payment`,
      };

      const { payment_session_id, orderId } = await post(
        "/admin/payment/payment-franchise/order",
        paymentDetails
      );
      if (payment_session_id) {
        // Build a clean return URL without duplicate parameters
        const url = new URL(window.location.href);
        url.searchParams.set("orderId", orderId);
        // url.searchParams.set("packageId", packageId);

        const checkoutOptions = {
          paymentSessionId: payment_session_id,
          returnUrl: url.toString(),
        };

        await cashfree.checkout(checkoutOptions).then(function (result) {
          if (result.error) {
            alert(result.error.message);
          }
        });
        await refreshPaymentStatus();
      } else {
        // showToast("Failed to create payment session. Please try again.");
      }
    } catch (error) {
      console.error("Error creating payment:", error);
      //   showToast("An error occurred while creating payment.");
    } finally {
      setLoading(false);
    }
  };
  // console.log(signedAdmin);

  return (
    <div>
      <div>
        <p className="text-white">
          user: <span className="text-yellow-500">{signedAdmin.email}</span>{" "}
        </p>
      </div>
      {signedAdmin.type === "employee" ? (
        <p className="text-white">You have valid access of admin</p>
      ) : signedAdmin.accessValidity &&
        isPackageActive(signedAdmin.accessValidity) ? (
        <p className="text-white">
          You have valid access of admin, validtill:{" "}
          {formatDateTime(signedAdmin.accessValidity || "")}
        </p>
      ) : (
        <div className="relative group bg-gradient-to-br from-green-500 to-green-700 p-6 rounded-lg shadow-lg w-80 transition-transform transform hover:-translate-y-2">
          <h3 className="text-2xl font-bold text-white mb-2">
            {adminPack.validity} days Access
          </h3>
          <p className="text-gray-200">Franchise admin pass package.</p>
          <div className="mt-4 space-y-2">
            <button
              disabled={loading}
              onClick={async () => {
                await handlePayment(
                  signedAdmin.franchisePackAmount || adminPack.amount
                );
              }}
              className="w-full bg-yellow-500 text-white py-2 rounded-md hover:bg-yellow-600 transition cursor-pointer"
            >
              {loading
                ? "Paying"
                : `Pay ₹${signedAdmin.franchisePackAmount || adminPack.amount}`}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPass;
